import React, {FunctionComponent, useEffect} from 'react';
import {RouteComponentProps, useHistory} from 'react-router-dom';
import {useSelector} from 'react-redux';
import _ from 'lodash';
import {selectUserHintsOrgIds} from '~/redux/selectors/userSelectors';
import {DEFAULT_ROUTABLE_ORG_ID, UIWrapper} from '../UIWrapper';
import {generateStoresPageRoute} from '~/Routes';

export const HomePage: FunctionComponent<RouteComponentProps> = (props: RouteComponentProps) => {
    const userOrgIds = useSelector(selectUserHintsOrgIds);
    const history = useHistory();

    const redirect = (path: string) => {
        history.push(path);
    };

    useEffect(() => {
        if (!_.isEmpty(userOrgIds)) {
            const orgId = _.get(userOrgIds, '[0]', DEFAULT_ROUTABLE_ORG_ID);
            const storeCatalogUrl = generateStoresPageRoute(orgId);
            redirect(storeCatalogUrl.pathname);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userOrgIds]);

    return (
        <UIWrapper>
            <div>Redirecting...</div>
        </UIWrapper>
    );
};

export default HomePage;
